import { Icon } from '@mirai-kids-monte/core/src/components/dataDisplay/Icon';
import { Company } from '@mirai-kids-monte/core/src/constants/Company';
import { type ReactNode } from 'react';
import styles from './index.module.scss';

type Props = {
  children?: ReactNode;
};

export const TelephoneButton = ({ children }: Props) => (
  <a href={`tel:${Company.PHONE.replace(/-/g, '')}`} target="_blank" rel="noopener noreferrer">
    <div className={styles.base}>
      <div className={styles['icon-wrapper']}>
        <Icon name="Telephone" size={30} />
      </div>
      <div>
        <div className={styles.text}>
          <p>{children ?? Company.PHONE}</p>
        </div>
        <div className={styles['sub-text']}>平日 9:00 ~ 18:00</div>
      </div>
      <div className={styles['add-friend']}>電話する</div>
    </div>
  </a>
);
